import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import SearchPage from './SearchPage';
import NewSearchPage from './NewSearchPage';

export default function SearchPageWrapper(props) {
	const location = useLocation();

	const isNewSearchPage = useSelector(
		(state) =>
			state.experiments?.bucket?.sf_16978_ssdc_clp_redesign ==
			'variation',
	);

	const params = location?.search
		? new URLSearchParams(location.search)
		: new URLSearchParams('');
	const queryParams = location?.search ? Object.fromEntries(params) : {};

	if (isNewSearchPage) {
		return (
			<NewSearchPage
				{...props}
				queryParams={queryParams}
				useNewSearch={isNewSearchPage}
			/>
		);
	}

	return (
		<SearchPage
			{...props}
			queryParams={queryParams}
		/>
	);
}
